module.exports = __webpack_public_path__ + "img/fietsmerin-video-2.e8084fc9.jpg";